<div class="title">
  <rt-heading variant="heading large-xx">
    {{ codename | rtProductName: { short: true } | titlecase }}
  </rt-heading>
  @if (showCustomBadge) {
    <rt-badge
      margin-left-small-x
      color="secondary"
      [text]="'app.pricing.plan_picker.customized' | translate"
      [rtTooltip]="
        'app.pricing.plan_picker.customized_tooltip'
          | translate: { planName: codename | rtProductName: { short: true } | titlecase }
      "
    />
  }

  @if (showTrialPlanBadge) {
    <rt-badge
      margin-left-small-x
      color="scale-reverse"
      [text]="'app.pricing.plan_picker.trial_plan' | translate"
    />
  }
</div>
<p [innerHTML]="codename | rtPlanPickerProductDescription"></p>
